export default __webpack_public_path__ + "static/media/menu icon.c551a7a2.svg";